import { createFileRoute } from "@tanstack/react-router";
import { useMe } from "@/hooks/useCloudChat";
import { SkillsSection } from "@/features/dashboard/SkillsSection";

function SkillsTab() {
  const { data: me } = useMe();
  const orgId = me?.organization?.id ?? "";
  return <SkillsSection orgId={orgId} />;
}

export const Route = createFileRoute("/_auth/_agents/settings/skills")({
  component: SkillsTab,
});
